import { raw, type Credential } from '../api/client';

/**
 * Saves a PDF the API answers with. The routes need the caller's credential,
 * so a plain link cannot fetch them: the bytes come through {@link raw} and
 * leave as an object URL the browser downloads under the server's file name.
 */
export async function downloadPdf(
  path: string,
  opts: { orgId: string; credential: Credential | null },
): Promise<void> {
  const response = await raw(path, opts);
  const disposition = response.headers.get('Content-Disposition') ?? '';
  const name = /filename="([^"]+)"/.exec(disposition)?.[1] ?? 'arbeitsblatt.pdf';
  const url = URL.createObjectURL(await response.blob());
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
